import React from 'react';
import './Playground.scss'

const Playground = () => {
  return (
    <div>Playground</div>
  )
}

export default Playground